import { Building2 } from 'lucide-react';
import { useAuthStore } from '@/lib/auth-store';

export function TenantSwitcher() {
  const tenantId = useAuthStore((s) => s.tenantId);
  const memberships = useAuthStore((s) => s.memberships);

  const current = memberships.find((m) => m.tenantId === tenantId);

  return (
    <div className="inline-flex items-center gap-2 px-3 py-2 text-sm text-[var(--fg)]">
      <Building2 className="h-4 w-4 shrink-0 text-[var(--fg-muted)]" />
      <span className="max-w-[200px] truncate">
        {current?.name ?? 'Escritório'}
      </span>
    </div>
  );
}
